import { useEffect, useState } from 'react';
import { Layout } from '@/components/Layout';
import { ProductCard } from '@/components/ProductCard';
import { api } from '@/lib/api';
import { useCart } from '@/lib/cart';
import { useSEO } from '@/lib/useSEO';
import { Tag } from 'lucide-react';
import { toast } from 'sonner';

/**
 * "Ofertas" landing. Muestra las promociones activas (productos con
 * `sponsored_until > now`) pagadas por vendedores o incluidas en su plan Pro.
 * El endpoint `/products/sponsored` ya devuelve los productos correctos,
 * priorizando los con vigencia más larga.
 */
export default function Ofertas() {
  const [items, setItems] = useState([]);
  const { add } = useCart();

  useSEO({
    title: 'Ofertas | AutoMarket Colombia',
    description: 'Descuentos y promociones destacadas en repuestos automotrices.',
    canonical: '/ofertas',
  });

  useEffect(() => {
    api.get('/products/sponsored', { params: { limit: 20 } })
      .then(({ data }) => setItems(data.items || []))
      .catch(() => {});
  }, []);

  return (
    <Layout>
      <section className="border-b border-slate-200 bg-slate-900 text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center bg-orange-500 text-slate-900">
            <Tag className="h-5 w-5" />
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-orange-400">Promociones</div>
            <h1 className="font-display text-3xl font-black tracking-tighter">Ofertas destacadas</h1>
          </div>
        </div>
      </section>

      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        {items.length === 0 ? (
          <p className="text-center text-slate-500 py-12">Todavía no hay ofertas activas. Vuelve pronto.</p>
        ) : (
          <div data-testid="ofertas-grid" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {items.map((p) => (
              <ProductCard key={p.product_id} product={p} onAdd={(prod) => { add(prod); toast.success(`${prod.name} agregado`); }} />
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
